import type { ReactNode } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { copyResponseToClipboard } from './copyResponseToClipboard';

export const CopyHeader = ({
  children,
  content,
}: {
  children: ReactNode;
  content: string | object;
}) => (
  <div className="my-1 flex flex-row items-center justify-between gap-1">
    <h4 className="text-size-headline-base font-semibold">{children}</h4>
    <Button onClick={() => copyResponseToClipboard(content)}>
      <span className="icon-emp-copy" />
      Copy to clipboard
    </Button>
  </div>
);
